var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('v-card',{staticClass:"card"},[_c('v-icon',{attrs:{"color":"foreground","x-large":""}},[_vm._v("mdi-cloud")]),_c('h1',[_vm._v("Configurações do Drive")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }